<msd-sidebar (signOut)="signOut()"
             (wrongConditionEvent)="onWrongCondition($event)"
             [dietitian]="(dashboardStatus$|async)?.dietitian"></msd-sidebar>
<router-outlet></router-outlet>
